module.exports = __webpack_public_path__ + "static/media/pixiv54839592-150x88.ba430c13.png";